import { XCircle } from 'lucide-react'

export function WhyItWorks() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-brand-navy mb-12">
          Por que isso funciona?
        </h2>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-slate-50 p-8 rounded-xl border border-slate-100">
            <div className="w-12 h-12 rounded-full bg-slate-200 mx-auto flex items-center justify-center mb-4">
              <XCircle className="w-6 h-6 text-slate-500" />
            </div>
            <h3 className="text-xl font-bold text-slate-700 mb-2">
              O que NÃO somos
            </h3>
            <p className="text-slate-600">
              Não somos um site de empregos genérico que te manda currículos de
              motorista para vaga de professor de matemática.
            </p>
          </div>

          <div className="bg-emerald-50 p-8 rounded-xl border border-emerald-100">
            <div className="w-12 h-12 rounded-full bg-emerald-200 mx-auto flex items-center justify-center mb-4">
              <span className="text-2xl">🎯</span>
            </div>
            <h3 className="text-xl font-bold text-brand-navy mb-2">
              O que SOMOS
            </h3>
            <p className="text-slate-700">
              Somos especialistas em educação. Falamos a língua da escola e
              entendemos a urgência de ter um professor em sala de aula.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
